import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import {
  ApprovalConfigurationModel,
  customerUpdateRequestModel,
} from "@models/approval/approvalModel"

class ApprovalService {
  // CONFIG
  public async CreateOrUpdatePosition(body: any) {
    const res = await http.post(
      "api/services/app/Approval/BulkCreateOrUpdatePosition",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async getConfig(id: any): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get(
      "api/services/app/Approval/GetRequestConfigurationDetail",
      {
        params: { id },
      }
    )
    const { result } = res.data
    return ApprovalConfigurationModel.assign(result)
  }

  public async bulkDelete(ids: any[]) {
    const res = await http.post("api/services/app/Approval/BulkDeleteFlow", ids)
    return res.data
  }

  public async getAllConfig(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get(
      "api/services/app/Approval/GetAllRequestConfiguration",
      { params }
    )
    return res.data.result
  }
  public async getRejectReason(params: any) {
    const res = await http.get("api/services/app/Approval/GetRejectReason", {
      params,
    })
    return res.data.result
  }
  // APPROVAL FLOW

  public async updateRequestStatus(body: any, timeout?: number) {
    const res = await http.put(
      "api/services/app/Approval/UpdateRequestStatus",
      body,
      {
        timeout: timeout || 120000, // Default 120 seconds for UpdateRequestStatus
      }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("APPROVAL_SUCCESSFULLY")
    )
    return res.data
  }

  // FOR CUSTOMER

  public async getAllCustomerUpdateRequest(
    params: any
  ): Promise<PagedResultDto<any>> {
    const res = await http.get(
      "api/services/app/Approval/GetAllCustomerUpdateRequest",
      { params }
    )
    return res.data.result
  }
  public async getCustomerUpdateRequest(id: any): Promise<PagedResultDto<any>> {
    const res = await http.get(
      "api/services/app/Approval/GetCustomerUpdateRequest",
      { params: { id } }
    )
    return customerUpdateRequestModel.assign(res.data.result)
  }

  public async getListApprovalHistory(params): Promise<any> {
    const res = await http.get(
      "api/services/app/Approval/GetListApprovalHistory",
      { params }
    )
    return res.data.result
  }
}

export default new ApprovalService()
